/**
 * Starter templates for the GrapeJS email editor.
 * 17 templates: 1 blank + 16 themed layouts.
 */

const STARTER_TEMPLATES = [
  {
    id: "blank",
    name: "Em branco",
    description: "Comece do zero com um canvas vazio",
    color: "#f1f5f9",
    icon: "blank",
    html: "",
  },
  {
    id: "newsletter",
    name: "Newsletter",
    description: "Layout cl&aacute;ssico para newsletters peri&oacute;dicas",
    color: "#dbeafe",
    icon: "newsletter",
    html: `<table width="100%" cellpadding="0" cellspacing="0" style="max-width:600px;margin:0 auto;font-family:'Segoe UI',Arial,Helvetica,sans-serif;background:#ffffff;">
  <tr><td style="background-color:#2563eb;padding:32px 40px;text-align:center;">
    <h1 style="color:#ffffff;font-size:26px;margin:0;font-weight:700;">Sua Newsletter</h1>
    <p style="color:#93c5fd;font-size:13px;margin:8px 0 0;letter-spacing:0.5px;">Edi&ccedil;&atilde;o Mensal &bull; Mar&ccedil;o 2026</p>
  </td></tr>
  <tr><td style="padding:32px 40px;">
    <table width="100%" cellpadding="0" cellspacing="0"><tr>
      <td style="width:4px;background:#2563eb;border-radius:4px;"></td>
      <td style="padding-left:16px;">
        <h2 style="color:#1e293b;font-size:20px;margin:0 0 8px;font-weight:700;">Destaque da semana</h2>
        <p style="color:#475569;font-size:14px;line-height:1.7;margin:0;">Escreva aqui o conte&uacute;do principal da sua newsletter. Compartilhe novidades, insights e informa&ccedil;&otilde;es relevantes para sua audi&ecirc;ncia.</p>
      </td>
    </tr></table>
  </td></tr>
  <tr><td style="padding:0 40px 32px;">
    <table width="100%" cellpadding="0" cellspacing="0"><tr>
      <td width="48%" style="vertical-align:top;">
        <div style="background:#f8fafc;border-radius:12px;padding:20px;border:1px solid #e2e8f0;">
          <div style="width:36px;height:36px;background:#dbeafe;border-radius:8px;text-align:center;line-height:36px;font-size:18px;margin-bottom:12px;">&#9733;</div>
          <h3 style="color:#1e293b;font-size:15px;margin:0 0 6px;font-weight:600;">Artigo 1</h3>
          <p style="color:#64748b;font-size:13px;line-height:1.5;margin:0 0 12px;">Resumo do primeiro artigo ou not&iacute;cia em destaque para seus leitores.</p>
          <a href="#" style="color:#2563eb;font-size:13px;font-weight:600;text-decoration:none;">Ler mais &rarr;</a>
        </div>
      </td>
      <td width="4%"></td>
      <td width="48%" style="vertical-align:top;">
        <div style="background:#f8fafc;border-radius:12px;padding:20px;border:1px solid #e2e8f0;">
          <div style="width:36px;height:36px;background:#dbeafe;border-radius:8px;text-align:center;line-height:36px;font-size:18px;margin-bottom:12px;">&#9830;</div>
          <h3 style="color:#1e293b;font-size:15px;margin:0 0 6px;font-weight:600;">Artigo 2</h3>
          <p style="color:#64748b;font-size:13px;line-height:1.5;margin:0 0 12px;">Resumo do segundo artigo ou not&iacute;cia em destaque para seus leitores.</p>
          <a href="#" style="color:#2563eb;font-size:13px;font-weight:600;text-decoration:none;">Ler mais &rarr;</a>
        </div>
      </td>
    </tr></table>
  </td></tr>
  <tr><td style="background:#f8fafc;padding:24px 40px;text-align:center;border-top:1px solid #e2e8f0;">
    <p style="color:#94a3b8;font-size:11px;margin:0 0 4px;">Voc&ecirc; recebeu este e-mail porque se cadastrou em nossa lista.</p>
    <p style="color:#94a3b8;font-size:11px;margin:0;"><a href="#" style="color:#2563eb;text-decoration:underline;">Cancelar inscri&ccedil;&atilde;o</a> &bull; <a href="#" style="color:#2563eb;text-decoration:underline;">Gerenciar prefer&ecirc;ncias</a></p>
  </td></tr>
</table>`,
  },
  {
    id: "promocao",
    name: "Promo&ccedil;&atilde;o",
    description: "Destaque ofertas e descontos especiais",
    color: "#fef3c7",
    icon: "promo",
    html: `<table width="100%" cellpadding="0" cellspacing="0" style="max-width:600px;margin:0 auto;font-family:'Segoe UI',Arial,Helvetica,sans-serif;background:#ffffff;">
  <tr><td style="background:linear-gradient(135deg,#f59e0b,#d97706);padding:40px;text-align:center;">
    <p style="color:#fffbeb;font-size:12px;text-transform:uppercase;letter-spacing:3px;margin:0 0 8px;font-weight:600;">Oferta especial</p>
    <h1 style="color:#ffffff;font-size:44px;margin:0 0 4px;font-weight:800;">30% OFF</h1>
    <p style="color:#fef3c7;font-size:15px;margin:0;">Em todos os produtos selecionados</p>
  </td></tr>
  <tr><td style="padding:32px 40px;text-align:center;">
    <h2 style="color:#1e293b;font-size:20px;margin:0 0 10px;font-weight:700;">N&atilde;o perca essa oportunidade!</h2>
    <p style="color:#475569;font-size:14px;line-height:1.7;margin:0 0 24px;">Aproveite descontos exclusivos por tempo limitado. Use o cupom abaixo no checkout e economize agora mesmo.</p>
    <div style="background:#fffbeb;border:2px dashed #f59e0b;border-radius:10px;padding:14px 28px;margin:0 auto 24px;display:inline-block;">
      <span style="color:#92400e;font-size:22px;font-weight:800;letter-spacing:4px;">PROMO30</span>
    </div>
    <br/>
    <a href="#" style="display:inline-block;background:#f59e0b;color:#fff;font-size:15px;font-weight:700;padding:14px 44px;border-radius:8px;text-decoration:none;">Comprar agora</a>
    <p style="color:#94a3b8;font-size:12px;margin:16px 0 0;">V&aacute;lido at&eacute; 31/12/2026 &bull; N&atilde;o acumul&aacute;vel</p>
  </td></tr>
  <tr><td style="background:#f8fafc;padding:20px 40px;text-align:center;border-top:1px solid #e2e8f0;">
    <p style="color:#94a3b8;font-size:11px;margin:0;"><a href="#" style="color:#f59e0b;text-decoration:underline;">Cancelar inscri&ccedil;&atilde;o</a></p>
  </td></tr>
</table>`,
  },
  {
    id: "produto",
    name: "Lan&ccedil;amento",
    description: "Anuncie novos produtos ou funcionalidades",
    color: "#ede9fe",
    icon: "launch",
    html: `<table width="100%" cellpadding="0" cellspacing="0" style="max-width:600px;margin:0 auto;font-family:'Segoe UI',Arial,Helvetica,sans-serif;background:#ffffff;">
  <tr><td style="background:#7c3aed;padding:40px;text-align:center;">
    <p style="color:#c4b5fd;font-size:12px;text-transform:uppercase;letter-spacing:3px;margin:0 0 12px;font-weight:600;">Novidade</p>
    <h1 style="color:#ffffff;font-size:28px;margin:0;font-weight:700;">Conhe&ccedil;a nosso novo produto</h1>
  </td></tr>
  <tr><td style="padding:0;">
    <div style="background:#f5f3ff;padding:32px 40px;text-align:center;">
      <div style="width:120px;height:120px;background:#ede9fe;border-radius:20px;margin:0 auto 20px;line-height:120px;font-size:48px;border:2px solid #ddd6fe;">&#9733;</div>
      <h2 style="color:#1e293b;font-size:22px;margin:0 0 6px;font-weight:700;">Nome do Produto</h2>
      <p style="color:#7c3aed;font-size:26px;font-weight:800;margin:0;">R$ 99,90</p>
      <p style="color:#94a3b8;font-size:12px;margin:4px 0 0;">ou 3x de R$ 33,30 sem juros</p>
    </div>
  </td></tr>
  <tr><td style="padding:28px 40px;">
    <h3 style="color:#1e293b;font-size:15px;margin:0 0 14px;font-weight:600;">Principais recursos:</h3>
    <table width="100%" cellpadding="0" cellspacing="0">
      <tr><td style="padding:10px 12px;color:#475569;font-size:13px;background:#f8fafc;border-radius:6px;">&#10003;&nbsp; Recurso incr&iacute;vel n&uacute;mero um</td></tr>
      <tr><td style="height:6px;"></td></tr>
      <tr><td style="padding:10px 12px;color:#475569;font-size:13px;background:#f8fafc;border-radius:6px;">&#10003;&nbsp; Recurso incr&iacute;vel n&uacute;mero dois</td></tr>
      <tr><td style="height:6px;"></td></tr>
      <tr><td style="padding:10px 12px;color:#475569;font-size:13px;background:#f8fafc;border-radius:6px;">&#10003;&nbsp; Recurso incr&iacute;vel n&uacute;mero tr&ecirc;s</td></tr>
    </table>
    <div style="text-align:center;margin:24px 0 0;">
      <a href="#" style="display:inline-block;background:#7c3aed;color:#fff;font-size:15px;font-weight:700;padding:14px 44px;border-radius:8px;text-decoration:none;">Saiba mais</a>
    </div>
  </td></tr>
  <tr><td style="background:#f8fafc;padding:20px 40px;text-align:center;border-top:1px solid #e2e8f0;">
    <p style="color:#94a3b8;font-size:11px;margin:0;"><a href="#" style="color:#7c3aed;text-decoration:underline;">Cancelar inscri&ccedil;&atilde;o</a></p>
  </td></tr>
</table>`,
  },
  {
    id: "boas-vindas",
    name: "Boas-vindas",
    description: "D&ecirc; as boas-vindas a novos contatos",
    color: "#d1fae5",
    icon: "welcome",
    html: `<table width="100%" cellpadding="0" cellspacing="0" style="max-width:600px;margin:0 auto;font-family:'Segoe UI',Arial,Helvetica,sans-serif;background:#ffffff;">
  <tr><td style="background:#059669;padding:40px;text-align:center;">
    <div style="width:56px;height:56px;background:rgba(255,255,255,0.2);border-radius:50%;margin:0 auto 14px;line-height:56px;font-size:26px;">&#9996;</div>
    <h1 style="color:#ffffff;font-size:28px;margin:0;font-weight:700;">Bem-vindo(a)!</h1>
    <p style="color:#a7f3d0;font-size:14px;margin:8px 0 0;">Estamos felizes em ter voc&ecirc; conosco</p>
  </td></tr>
  <tr><td style="padding:32px 40px;">
    <p style="color:#1e293b;font-size:15px;line-height:1.7;margin:0 0 16px;">Ol&aacute; <strong>{nome}</strong>,</p>
    <p style="color:#475569;font-size:14px;line-height:1.7;margin:0 0 24px;">Obrigado por se juntar a n&oacute;s! Preparamos tudo para que voc&ecirc; tenha a melhor experi&ecirc;ncia. Siga os passos abaixo para come&ccedil;ar:</p>
    <table width="100%" cellpadding="0" cellspacing="0">
      <tr><td style="padding:14px 16px;background:#f0fdf4;border-radius:10px;border-left:4px solid #059669;">
        <strong style="color:#059669;font-size:14px;">1.</strong> <span style="color:#1e293b;font-size:14px;margin-left:4px;">Complete seu perfil com suas informa&ccedil;&otilde;es</span>
      </td></tr>
      <tr><td style="height:8px;"></td></tr>
      <tr><td style="padding:14px 16px;background:#f0fdf4;border-radius:10px;border-left:4px solid #059669;">
        <strong style="color:#059669;font-size:14px;">2.</strong> <span style="color:#1e293b;font-size:14px;margin-left:4px;">Explore nossos recursos e ferramentas</span>
      </td></tr>
      <tr><td style="height:8px;"></td></tr>
      <tr><td style="padding:14px 16px;background:#f0fdf4;border-radius:10px;border-left:4px solid #059669;">
        <strong style="color:#059669;font-size:14px;">3.</strong> <span style="color:#1e293b;font-size:14px;margin-left:4px;">Conecte-se com a equipe de suporte</span>
      </td></tr>
    </table>
    <div style="text-align:center;margin:28px 0 0;">
      <a href="#" style="display:inline-block;background:#059669;color:#fff;font-size:15px;font-weight:700;padding:14px 44px;border-radius:8px;text-decoration:none;">Acessar minha conta</a>
    </div>
  </td></tr>
  <tr><td style="background:#f8fafc;padding:20px 40px;text-align:center;border-top:1px solid #e2e8f0;">
    <p style="color:#94a3b8;font-size:11px;margin:0;">Precisa de ajuda? Responda este e-mail. <a href="#" style="color:#059669;text-decoration:underline;">Cancelar inscri&ccedil;&atilde;o</a></p>
  </td></tr>
</table>`,
  },
  {
    id: "convite-evento",
    name: "Evento",
    description: "Convites para webinars, eventos e encontros",
    color: "#fce7f3",
    icon: "event",
    html: `<table width="100%" cellpadding="0" cellspacing="0" style="max-width:600px;margin:0 auto;font-family:'Segoe UI',Arial,Helvetica,sans-serif;background:#ffffff;">
  <tr><td style="background:linear-gradient(135deg,#ec4899,#be185d);padding:40px;text-align:center;">
    <p style="color:#fce7f3;font-size:12px;text-transform:uppercase;letter-spacing:3px;margin:0 0 12px;font-weight:600;">Voc&ecirc; est&aacute; convidado(a)</p>
    <h1 style="color:#ffffff;font-size:28px;margin:0 0 16px;font-weight:700;">Nome do Evento</h1>
    <div style="background:rgba(255,255,255,0.15);border-radius:10px;padding:12px 24px;display:inline-block;">
      <span style="color:#ffffff;font-size:14px;font-weight:600;">15 de Abril, 2026 &bull; 19h00 (BRT)</span>
    </div>
  </td></tr>
  <tr><td style="padding:32px 40px;">
    <p style="color:#475569;font-size:14px;line-height:1.7;margin:0 0 24px;">Participe do nosso pr&oacute;ximo evento exclusivo! Teremos palestras incr&iacute;veis, networking e muito conte&uacute;do relevante.</p>
    <table width="100%" cellpadding="0" cellspacing="0" style="background:#fdf2f8;border-radius:12px;overflow:hidden;">
      <tr><td style="padding:14px 20px;border-bottom:1px solid #fce7f3;"><strong style="color:#1e293b;font-size:13px;">Local:</strong> <span style="color:#475569;font-size:13px;">Online (Zoom)</span></td></tr>
      <tr><td style="padding:14px 20px;border-bottom:1px solid #fce7f3;"><strong style="color:#1e293b;font-size:13px;">Dura&ccedil;&atilde;o:</strong> <span style="color:#475569;font-size:13px;">2 horas</span></td></tr>
      <tr><td style="padding:14px 20px;"><strong style="color:#1e293b;font-size:13px;">Vagas:</strong> <span style="color:#475569;font-size:13px;">Limitadas</span></td></tr>
    </table>
    <div style="text-align:center;margin:28px 0 0;">
      <a href="#" style="display:inline-block;background:#ec4899;color:#fff;font-size:15px;font-weight:700;padding:14px 44px;border-radius:8px;text-decoration:none;">Confirmar presen&ccedil;a</a>
    </div>
  </td></tr>
  <tr><td style="background:#f8fafc;padding:20px 40px;text-align:center;border-top:1px solid #e2e8f0;">
    <p style="color:#94a3b8;font-size:11px;margin:0;"><a href="#" style="color:#ec4899;text-decoration:underline;">Cancelar inscri&ccedil;&atilde;o</a></p>
  </td></tr>
</table>`,
  },
  {
    id: "feedback",
    name: "Pesquisa",
    description: "Pe&ccedil;a feedback ou avalia&ccedil;&otilde;es",
    color: "#e0f2fe",
    icon: "feedback",
    html: `<table width="100%" cellpadding="0" cellspacing="0" style="max-width:600px;margin:0 auto;font-family:'Segoe UI',Arial,Helvetica,sans-serif;background:#ffffff;">
  <tr><td style="background:#0284c7;padding:36px 40px;text-align:center;">
    <h1 style="color:#ffffff;font-size:26px;margin:0;font-weight:700;">Sua opini&atilde;o importa!</h1>
    <p style="color:#bae6fd;font-size:14px;margin:8px 0 0;">Nos ajude a melhorar nossos servi&ccedil;os</p>
  </td></tr>
  <tr><td style="padding:32px 40px;text-align:center;">
    <p style="color:#475569;font-size:14px;line-height:1.7;margin:0 0 24px;">Ol&aacute; <strong>{nome}</strong>, gostar&iacute;amos de saber como foi sua experi&ecirc;ncia. Sua opini&atilde;o &eacute; fundamental para continuarmos evoluindo.</p>
    <p style="color:#1e293b;font-size:16px;font-weight:600;margin:0 0 20px;">Como voc&ecirc; avalia nosso servi&ccedil;o?</p>
    <table cellpadding="0" cellspacing="0" style="margin:0 auto;">
      <tr>
        <td style="padding:0 8px;"><a href="#" style="display:inline-block;width:52px;height:52px;line-height:52px;background:#fee2e2;border-radius:50%;text-decoration:none;font-size:26px;text-align:center;">&#128542;</a></td>
        <td style="padding:0 8px;"><a href="#" style="display:inline-block;width:52px;height:52px;line-height:52px;background:#fef3c7;border-radius:50%;text-decoration:none;font-size:26px;text-align:center;">&#128528;</a></td>
        <td style="padding:0 8px;"><a href="#" style="display:inline-block;width:52px;height:52px;line-height:52px;background:#d1fae5;border-radius:50%;text-decoration:none;font-size:26px;text-align:center;">&#128522;</a></td>
        <td style="padding:0 8px;"><a href="#" style="display:inline-block;width:52px;height:52px;line-height:52px;background:#bbf7d0;border-radius:50%;text-decoration:none;font-size:26px;text-align:center;">&#128525;</a></td>
      </tr>
    </table>
    <div style="margin:28px 0 0;">
      <a href="#" style="display:inline-block;background:#0284c7;color:#fff;font-size:15px;font-weight:700;padding:14px 44px;border-radius:8px;text-decoration:none;">Responder pesquisa completa</a>
    </div>
  </td></tr>
  <tr><td style="background:#f8fafc;padding:20px 40px;text-align:center;border-top:1px solid #e2e8f0;">
    <p style="color:#94a3b8;font-size:11px;margin:0;"><a href="#" style="color:#0284c7;text-decoration:underline;">Cancelar inscri&ccedil;&atilde;o</a></p>
  </td></tr>
</table>`,
  },
  {
    id: "atualizacao",
    name: "Atualiza&ccedil;&atilde;o",
    description: "Comunique mudan&ccedil;as e novidades do produto",
    color: "#dbeafe",
    icon: "newsletter",
    html: `<table width="100%" cellpadding="0" cellspacing="0" style="max-width:600px;margin:0 auto;font-family:'Segoe UI',Arial,Helvetica,sans-serif;background:#ffffff;">
  <tr><td style="background:#1e40af;padding:32px 40px;">
    <table width="100%" cellpadding="0" cellspacing="0"><tr>
      <td><p style="color:#93c5fd;font-size:11px;text-transform:uppercase;letter-spacing:2px;margin:0;font-weight:600;">Product Update</p>
        <h1 style="color:#ffffff;font-size:24px;margin:6px 0 0;font-weight:700;">O que h&aacute; de novo</h1></td>
      <td style="text-align:right;"><div style="background:rgba(255,255,255,0.15);border-radius:8px;padding:8px 14px;display:inline-block;"><span style="color:#ffffff;font-size:13px;font-weight:600;">v2.5</span></div></td>
    </tr></table>
  </td></tr>
  <tr><td style="padding:32px 40px;">
    <div style="border-left:3px solid #2563eb;padding-left:16px;margin-bottom:24px;">
      <span style="display:inline-block;background:#dbeafe;color:#1e40af;font-size:10px;font-weight:700;padding:3px 8px;border-radius:4px;text-transform:uppercase;margin-bottom:8px;">Novo</span>
      <h3 style="color:#1e293b;font-size:16px;margin:0 0 6px;font-weight:600;">Dashboard redesenhado</h3>
      <p style="color:#64748b;font-size:13px;line-height:1.6;margin:0;">Nova interface mais limpa e intuitiva com gr&aacute;ficos interativos e m&eacute;tricas em tempo real.</p>
    </div>
    <div style="border-left:3px solid #10b981;padding-left:16px;margin-bottom:24px;">
      <span style="display:inline-block;background:#d1fae5;color:#065f46;font-size:10px;font-weight:700;padding:3px 8px;border-radius:4px;text-transform:uppercase;margin-bottom:8px;">Melhoria</span>
      <h3 style="color:#1e293b;font-size:16px;margin:0 0 6px;font-weight:600;">Performance 3x mais r&aacute;pida</h3>
      <p style="color:#64748b;font-size:13px;line-height:1.6;margin:0;">Otimizamos consultas e cache para uma experi&ecirc;ncia muito mais fluida.</p>
    </div>
    <div style="border-left:3px solid #f59e0b;padding-left:16px;">
      <span style="display:inline-block;background:#fef3c7;color:#92400e;font-size:10px;font-weight:700;padding:3px 8px;border-radius:4px;text-transform:uppercase;margin-bottom:8px;">Corre&ccedil;&atilde;o</span>
      <h3 style="color:#1e293b;font-size:16px;margin:0 0 6px;font-weight:600;">Bug no relat&oacute;rio corrigido</h3>
      <p style="color:#64748b;font-size:13px;line-height:1.6;margin:0;">Resolvemos o problema que impedia a exporta&ccedil;&atilde;o em PDF de relat&oacute;rios longos.</p>
    </div>
  </td></tr>
  <tr><td style="padding:0 40px 28px;text-align:center;">
    <a href="#" style="display:inline-block;background:#1e40af;color:#fff;font-size:14px;font-weight:700;padding:12px 36px;border-radius:8px;text-decoration:none;">Ver todas as novidades</a>
  </td></tr>
  <tr><td style="background:#f8fafc;padding:20px 40px;text-align:center;border-top:1px solid #e2e8f0;">
    <p style="color:#94a3b8;font-size:11px;margin:0;"><a href="#" style="color:#1e40af;text-decoration:underline;">Cancelar inscri&ccedil;&atilde;o</a></p>
  </td></tr>
</table>`,
  },
  {
    id: "abandono-carrinho",
    name: "Carrinho Abandonado",
    description: "Recupere vendas de carrinhos n&atilde;o finalizados",
    color: "#fee2e2",
    icon: "feedback",
    html: `<table width="100%" cellpadding="0" cellspacing="0" style="max-width:600px;margin:0 auto;font-family:'Segoe UI',Arial,Helvetica,sans-serif;background:#ffffff;">
  <tr><td style="background:#dc2626;padding:32px 40px;text-align:center;">
    <h1 style="color:#ffffff;font-size:24px;margin:0;font-weight:700;">Voc&ecirc; esqueceu algo!</h1>
    <p style="color:#fecaca;font-size:13px;margin:8px 0 0;">Seus itens ainda est&atilde;o esperando por voc&ecirc;</p>
  </td></tr>
  <tr><td style="padding:32px 40px;">
    <p style="color:#475569;font-size:14px;line-height:1.7;margin:0 0 24px;">Ol&aacute; <strong>{nome}</strong>, notamos que voc&ecirc; deixou itens no carrinho. Finalize sua compra antes que eles esgotem!</p>
    <table width="100%" cellpadding="0" cellspacing="0" style="border:1px solid #e2e8f0;border-radius:12px;overflow:hidden;">
      <tr style="background:#f8fafc;">
        <td style="padding:14px 16px;"><div style="width:60px;height:60px;background:#fee2e2;border-radius:8px;text-align:center;line-height:60px;font-size:24px;">&#128722;</div></td>
        <td style="padding:14px 16px;">
          <p style="color:#1e293b;font-size:14px;font-weight:600;margin:0;">Produto Exemplo</p>
          <p style="color:#64748b;font-size:12px;margin:4px 0 0;">Qtd: 1 &bull; Tamanho: M</p>
        </td>
        <td style="padding:14px 16px;text-align:right;">
          <p style="color:#1e293b;font-size:16px;font-weight:700;margin:0;">R$ 189,90</p>
        </td>
      </tr>
    </table>
    <div style="text-align:center;margin:24px 0 0;">
      <a href="#" style="display:inline-block;background:#dc2626;color:#fff;font-size:15px;font-weight:700;padding:14px 44px;border-radius:8px;text-decoration:none;">Finalizar compra</a>
      <p style="color:#94a3b8;font-size:12px;margin:12px 0 0;">Frete gr&aacute;tis para compras acima de R$ 150</p>
    </div>
  </td></tr>
  <tr><td style="background:#f8fafc;padding:20px 40px;text-align:center;border-top:1px solid #e2e8f0;">
    <p style="color:#94a3b8;font-size:11px;margin:0;"><a href="#" style="color:#dc2626;text-decoration:underline;">Cancelar inscri&ccedil;&atilde;o</a></p>
  </td></tr>
</table>`,
  },
  {
    id: "obrigado",
    name: "Agradecimento",
    description: "Agrade&ccedil;a ap&oacute;s compra ou a&ccedil;&atilde;o",
    color: "#d1fae5",
    icon: "welcome",
    html: `<table width="100%" cellpadding="0" cellspacing="0" style="max-width:600px;margin:0 auto;font-family:'Segoe UI',Arial,Helvetica,sans-serif;background:#ffffff;">
  <tr><td style="padding:40px;text-align:center;">
    <div style="width:72px;height:72px;background:#d1fae5;border-radius:50%;margin:0 auto 16px;line-height:72px;font-size:36px;">&#10003;</div>
    <h1 style="color:#059669;font-size:28px;margin:0 0 8px;font-weight:700;">Obrigado, {nome}!</h1>
    <p style="color:#475569;font-size:15px;line-height:1.7;margin:0;">Seu pedido <strong>#12345</strong> foi confirmado com sucesso.</p>
  </td></tr>
  <tr><td style="padding:0 40px 32px;">
    <table width="100%" cellpadding="0" cellspacing="0" style="background:#f8fafc;border-radius:12px;overflow:hidden;">
      <tr><td style="padding:16px 20px;border-bottom:1px solid #e2e8f0;">
        <p style="color:#94a3b8;font-size:11px;text-transform:uppercase;letter-spacing:1px;margin:0 0 4px;">Resumo do pedido</p>
      </td></tr>
      <tr><td style="padding:14px 20px;border-bottom:1px solid #f1f5f9;">
        <table width="100%"><tr><td style="color:#475569;font-size:13px;">Produto Exemplo x1</td><td style="text-align:right;color:#1e293b;font-size:13px;font-weight:600;">R$ 189,90</td></tr></table>
      </td></tr>
      <tr><td style="padding:14px 20px;border-bottom:1px solid #f1f5f9;">
        <table width="100%"><tr><td style="color:#475569;font-size:13px;">Frete</td><td style="text-align:right;color:#059669;font-size:13px;font-weight:600;">Gr&aacute;tis</td></tr></table>
      </td></tr>
      <tr><td style="padding:14px 20px;">
        <table width="100%"><tr><td style="color:#1e293b;font-size:15px;font-weight:700;">Total</td><td style="text-align:right;color:#1e293b;font-size:15px;font-weight:700;">R$ 189,90</td></tr></table>
      </td></tr>
    </table>
  </td></tr>
  <tr><td style="padding:0 40px 28px;text-align:center;">
    <a href="#" style="display:inline-block;background:#059669;color:#fff;font-size:14px;font-weight:700;padding:12px 36px;border-radius:8px;text-decoration:none;">Acompanhar pedido</a>
  </td></tr>
  <tr><td style="background:#f8fafc;padding:20px 40px;text-align:center;border-top:1px solid #e2e8f0;">
    <p style="color:#94a3b8;font-size:11px;margin:0;">D&uacute;vidas? Responda este e-mail. <a href="#" style="color:#059669;text-decoration:underline;">Cancelar inscri&ccedil;&atilde;o</a></p>
  </td></tr>
</table>`,
  },
  {
    id: "reengajamento",
    name: "Reengajamento",
    description: "Reconecte com contatos inativos",
    color: "#fef9c3",
    icon: "feedback",
    html: `<table width="100%" cellpadding="0" cellspacing="0" style="max-width:600px;margin:0 auto;font-family:'Segoe UI',Arial,Helvetica,sans-serif;background:#ffffff;">
  <tr><td style="padding:40px;text-align:center;">
    <div style="font-size:48px;margin-bottom:12px;">&#128075;</div>
    <h1 style="color:#1e293b;font-size:26px;margin:0 0 8px;font-weight:700;">Sentimos sua falta!</h1>
    <p style="color:#64748b;font-size:14px;line-height:1.6;margin:0;">Faz tempo que n&atilde;o nos vemos, <strong>{nome}</strong>. Muita coisa mudou e gostar&iacute;amos de te mostrar!</p>
  </td></tr>
  <tr><td style="padding:0 40px 32px;">
    <table width="100%" cellpadding="0" cellspacing="0">
      <tr>
        <td width="48%" style="vertical-align:top;">
          <div style="background:#fefce8;border-radius:12px;padding:20px;text-align:center;border:1px solid #fef08a;">
            <div style="font-size:28px;margin-bottom:8px;">&#128640;</div>
            <h3 style="color:#1e293b;font-size:14px;margin:0 0 4px;font-weight:600;">Novos recursos</h3>
            <p style="color:#64748b;font-size:12px;line-height:1.5;margin:0;">Lan&ccedil;amos funcionalidades incr&iacute;veis.</p>
          </div>
        </td>
        <td width="4%"></td>
        <td width="48%" style="vertical-align:top;">
          <div style="background:#fefce8;border-radius:12px;padding:20px;text-align:center;border:1px solid #fef08a;">
            <div style="font-size:28px;margin-bottom:8px;">&#127873;</div>
            <h3 style="color:#1e293b;font-size:14px;margin:0 0 4px;font-weight:600;">Oferta especial</h3>
            <p style="color:#64748b;font-size:12px;line-height:1.5;margin:0;">20% de desconto exclusivo para voc&ecirc;.</p>
          </div>
        </td>
      </tr>
    </table>
  </td></tr>
  <tr><td style="padding:0 40px 32px;text-align:center;">
    <a href="#" style="display:inline-block;background:#ca8a04;color:#fff;font-size:15px;font-weight:700;padding:14px 44px;border-radius:8px;text-decoration:none;">Voltar agora</a>
  </td></tr>
  <tr><td style="background:#f8fafc;padding:20px 40px;text-align:center;border-top:1px solid #e2e8f0;">
    <p style="color:#94a3b8;font-size:11px;margin:0;">N&atilde;o quer mais receber? <a href="#" style="color:#ca8a04;text-decoration:underline;">Cancelar inscri&ccedil;&atilde;o</a></p>
  </td></tr>
</table>`,
  },
  {
    id: "depoimento",
    name: "Depoimento / Case",
    description: "Compartilhe hist&oacute;rias de sucesso de clientes",
    color: "#f0fdf4",
    icon: "welcome",
    html: `<table width="100%" cellpadding="0" cellspacing="0" style="max-width:600px;margin:0 auto;font-family:'Segoe UI',Arial,Helvetica,sans-serif;background:#ffffff;">
  <tr><td style="background:#166534;padding:32px 40px;text-align:center;">
    <p style="color:#86efac;font-size:12px;text-transform:uppercase;letter-spacing:3px;margin:0 0 8px;font-weight:600;">Case de sucesso</p>
    <h1 style="color:#ffffff;font-size:24px;margin:0;font-weight:700;">Veja como a Empresa X cresceu 300%</h1>
  </td></tr>
  <tr><td style="padding:32px 40px;">
    <div style="background:#f0fdf4;border-radius:12px;padding:24px;border-left:4px solid #16a34a;margin-bottom:24px;">
      <p style="color:#475569;font-size:15px;line-height:1.7;font-style:italic;margin:0 0 12px;">"Desde que come&ccedil;amos a usar a plataforma, nossos resultados triplicaram. A equipe de suporte &eacute; excepcional e as ferramentas s&atilde;o intuitivas."</p>
      <p style="color:#1e293b;font-size:13px;font-weight:600;margin:0;">Maria Silva, CEO da Empresa X</p>
    </div>
    <table width="100%" cellpadding="0" cellspacing="0">
      <tr>
        <td width="30%" style="text-align:center;padding:12px;">
          <p style="color:#16a34a;font-size:28px;font-weight:800;margin:0;">300%</p>
          <p style="color:#64748b;font-size:11px;margin:4px 0 0;">Crescimento</p>
        </td>
        <td width="5%"><div style="width:1px;height:40px;background:#e2e8f0;margin:0 auto;"></div></td>
        <td width="30%" style="text-align:center;padding:12px;">
          <p style="color:#16a34a;font-size:28px;font-weight:800;margin:0;">2x</p>
          <p style="color:#64748b;font-size:11px;margin:4px 0 0;">Produtividade</p>
        </td>
        <td width="5%"><div style="width:1px;height:40px;background:#e2e8f0;margin:0 auto;"></div></td>
        <td width="30%" style="text-align:center;padding:12px;">
          <p style="color:#16a34a;font-size:28px;font-weight:800;margin:0;">98%</p>
          <p style="color:#64748b;font-size:11px;margin:4px 0 0;">Satisfa&ccedil;&atilde;o</p>
        </td>
      </tr>
    </table>
  </td></tr>
  <tr><td style="padding:0 40px 28px;text-align:center;">
    <a href="#" style="display:inline-block;background:#16a34a;color:#fff;font-size:14px;font-weight:700;padding:12px 36px;border-radius:8px;text-decoration:none;">Ler case completo</a>
  </td></tr>
  <tr><td style="background:#f8fafc;padding:20px 40px;text-align:center;border-top:1px solid #e2e8f0;">
    <p style="color:#94a3b8;font-size:11px;margin:0;"><a href="#" style="color:#16a34a;text-decoration:underline;">Cancelar inscri&ccedil;&atilde;o</a></p>
  </td></tr>
</table>`,
  },
  {
    id: "aviso-cobranca",
    name: "Lembrete de Pagamento",
    description: "Avise sobre faturas pendentes ou vencidas",
    color: "#ffedd5",
    icon: "feedback",
    html: `<table width="100%" cellpadding="0" cellspacing="0" style="max-width:600px;margin:0 auto;font-family:'Segoe UI',Arial,Helvetica,sans-serif;background:#ffffff;">
  <tr><td style="background:#ea580c;padding:32px 40px;text-align:center;">
    <h1 style="color:#ffffff;font-size:24px;margin:0;font-weight:700;">Lembrete de Pagamento</h1>
    <p style="color:#fed7aa;font-size:13px;margin:8px 0 0;">Sua fatura est&aacute; pr&oacute;xima do vencimento</p>
  </td></tr>
  <tr><td style="padding:32px 40px;">
    <p style="color:#475569;font-size:14px;line-height:1.7;margin:0 0 24px;">Ol&aacute; <strong>{nome}</strong>, este &eacute; um lembrete amig&aacute;vel sobre sua fatura pendente. Abaixo est&atilde;o os detalhes:</p>
    <table width="100%" cellpadding="0" cellspacing="0" style="background:#fff7ed;border-radius:12px;overflow:hidden;border:1px solid #fed7aa;">
      <tr><td style="padding:16px 20px;border-bottom:1px solid #fed7aa;">
        <table width="100%"><tr><td style="color:#64748b;font-size:13px;">Fatura</td><td style="text-align:right;color:#1e293b;font-size:13px;font-weight:600;">#INV-2026-001</td></tr></table>
      </td></tr>
      <tr><td style="padding:16px 20px;border-bottom:1px solid #fed7aa;">
        <table width="100%"><tr><td style="color:#64748b;font-size:13px;">Vencimento</td><td style="text-align:right;color:#ea580c;font-size:13px;font-weight:600;">05/04/2026</td></tr></table>
      </td></tr>
      <tr><td style="padding:16px 20px;">
        <table width="100%"><tr><td style="color:#1e293b;font-size:15px;font-weight:700;">Valor</td><td style="text-align:right;color:#1e293b;font-size:18px;font-weight:800;">R$ 299,00</td></tr></table>
      </td></tr>
    </table>
    <div style="text-align:center;margin:24px 0 0;">
      <a href="#" style="display:inline-block;background:#ea580c;color:#fff;font-size:15px;font-weight:700;padding:14px 44px;border-radius:8px;text-decoration:none;">Pagar agora</a>
    </div>
  </td></tr>
  <tr><td style="background:#f8fafc;padding:20px 40px;text-align:center;border-top:1px solid #e2e8f0;">
    <p style="color:#94a3b8;font-size:11px;margin:0;">D&uacute;vidas sobre cobran&ccedil;a? Responda este e-mail. <a href="#" style="color:#ea580c;text-decoration:underline;">Cancelar inscri&ccedil;&atilde;o</a></p>
  </td></tr>
</table>`,
  },
  {
    id: "convite-indicacao",
    name: "Programa de Indica&ccedil;&atilde;o",
    description: "Incentive indica&ccedil;&otilde;es com recompensas",
    color: "#e0e7ff",
    icon: "launch",
    html: `<table width="100%" cellpadding="0" cellspacing="0" style="max-width:600px;margin:0 auto;font-family:'Segoe UI',Arial,Helvetica,sans-serif;background:#ffffff;">
  <tr><td style="background:linear-gradient(135deg,#4f46e5,#7c3aed);padding:40px;text-align:center;">
    <div style="font-size:40px;margin-bottom:12px;">&#127381;</div>
    <h1 style="color:#ffffff;font-size:26px;margin:0 0 8px;font-weight:700;">Indique e Ganhe!</h1>
    <p style="color:#c7d2fe;font-size:14px;margin:0;">Convide amigos e ganhe recompensas incr&iacute;veis</p>
  </td></tr>
  <tr><td style="padding:32px 40px;text-align:center;">
    <p style="color:#475569;font-size:14px;line-height:1.7;margin:0 0 24px;">A cada amigo que se cadastrar usando seu link, voc&ecirc; ganha <strong style="color:#4f46e5;">R$ 50 em cr&eacute;ditos</strong>. Sem limite de indica&ccedil;&otilde;es!</p>
    <table width="100%" cellpadding="0" cellspacing="0">
      <tr>
        <td width="30%" style="text-align:center;padding:16px;">
          <div style="width:48px;height:48px;background:#e0e7ff;border-radius:12px;margin:0 auto 8px;line-height:48px;font-size:20px;">1</div>
          <p style="color:#1e293b;font-size:12px;font-weight:600;margin:0;">Compartilhe</p>
          <p style="color:#94a3b8;font-size:11px;margin:2px 0 0;">Seu link &uacute;nico</p>
        </td>
        <td width="5%" style="color:#cbd5e1;text-align:center;">&rarr;</td>
        <td width="30%" style="text-align:center;padding:16px;">
          <div style="width:48px;height:48px;background:#e0e7ff;border-radius:12px;margin:0 auto 8px;line-height:48px;font-size:20px;">2</div>
          <p style="color:#1e293b;font-size:12px;font-weight:600;margin:0;">Amigo se cadastra</p>
          <p style="color:#94a3b8;font-size:11px;margin:2px 0 0;">Usando seu link</p>
        </td>
        <td width="5%" style="color:#cbd5e1;text-align:center;">&rarr;</td>
        <td width="30%" style="text-align:center;padding:16px;">
          <div style="width:48px;height:48px;background:#e0e7ff;border-radius:12px;margin:0 auto 8px;line-height:48px;font-size:20px;">3</div>
          <p style="color:#1e293b;font-size:12px;font-weight:600;margin:0;">Ganhe R$ 50</p>
          <p style="color:#94a3b8;font-size:11px;margin:2px 0 0;">Em cr&eacute;ditos</p>
        </td>
      </tr>
    </table>
    <div style="background:#f5f3ff;border-radius:10px;padding:14px 20px;margin:20px 0 0;">
      <p style="color:#64748b;font-size:12px;margin:0 0 6px;">Seu link de indica&ccedil;&atilde;o:</p>
      <p style="color:#4f46e5;font-size:14px;font-weight:700;margin:0;word-break:break-all;">https://app.exemplo.com/ref/SEU-CODIGO</p>
    </div>
    <div style="margin:24px 0 0;">
      <a href="#" style="display:inline-block;background:#4f46e5;color:#fff;font-size:15px;font-weight:700;padding:14px 44px;border-radius:8px;text-decoration:none;">Indicar agora</a>
    </div>
  </td></tr>
  <tr><td style="background:#f8fafc;padding:20px 40px;text-align:center;border-top:1px solid #e2e8f0;">
    <p style="color:#94a3b8;font-size:11px;margin:0;"><a href="#" style="color:#4f46e5;text-decoration:underline;">Cancelar inscri&ccedil;&atilde;o</a></p>
  </td></tr>
</table>`,
  },
  {
    id: "aniversario",
    name: "Anivers&aacute;rio",
    description: "Parabenize clientes em datas especiais",
    color: "#fce7f3",
    icon: "event",
    html: `<table width="100%" cellpadding="0" cellspacing="0" style="max-width:600px;margin:0 auto;font-family:'Segoe UI',Arial,Helvetica,sans-serif;background:#ffffff;">
  <tr><td style="background:linear-gradient(135deg,#f472b6,#ec4899,#a855f7);padding:44px 40px;text-align:center;">
    <div style="font-size:48px;margin-bottom:12px;">&#127874;</div>
    <h1 style="color:#ffffff;font-size:30px;margin:0 0 6px;font-weight:800;">Feliz Anivers&aacute;rio!</h1>
    <p style="color:#fce7f3;font-size:15px;margin:0;font-weight:500;">{nome}, hoje &eacute; o seu dia!</p>
  </td></tr>
  <tr><td style="padding:32px 40px;text-align:center;">
    <p style="color:#475569;font-size:14px;line-height:1.7;margin:0 0 24px;">Para celebrar esta data especial, preparamos um presente exclusivo para voc&ecirc;. Aproveite!</p>
    <div style="background:linear-gradient(135deg,#fdf2f8,#fce7f3);border-radius:16px;padding:28px;border:2px dashed #f9a8d4;margin-bottom:24px;">
      <p style="color:#be185d;font-size:12px;text-transform:uppercase;letter-spacing:2px;font-weight:600;margin:0 0 8px;">Cupom exclusivo</p>
      <p style="color:#be185d;font-size:32px;font-weight:800;margin:0 0 4px;">25% OFF</p>
      <p style="color:#f472b6;font-size:14px;margin:0;">Use: <strong>NIVER25</strong></p>
    </div>
    <a href="#" style="display:inline-block;background:#ec4899;color:#fff;font-size:15px;font-weight:700;padding:14px 44px;border-radius:8px;text-decoration:none;">Resgatar presente</a>
    <p style="color:#94a3b8;font-size:12px;margin:14px 0 0;">V&aacute;lido por 7 dias</p>
  </td></tr>
  <tr><td style="background:#f8fafc;padding:20px 40px;text-align:center;border-top:1px solid #e2e8f0;">
    <p style="color:#94a3b8;font-size:11px;margin:0;"><a href="#" style="color:#ec4899;text-decoration:underline;">Cancelar inscri&ccedil;&atilde;o</a></p>
  </td></tr>
</table>`,
  },
  {
    id: "tutorial",
    name: "Tutorial / Onboarding",
    description: "Guie usu&aacute;rios em etapas do produto",
    color: "#dbeafe",
    icon: "newsletter",
    html: `<table width="100%" cellpadding="0" cellspacing="0" style="max-width:600px;margin:0 auto;font-family:'Segoe UI',Arial,Helvetica,sans-serif;background:#ffffff;">
  <tr><td style="background:#0369a1;padding:32px 40px;">
    <p style="color:#7dd3fc;font-size:12px;text-transform:uppercase;letter-spacing:2px;margin:0 0 6px;font-weight:600;">Guia r&aacute;pido</p>
    <h1 style="color:#ffffff;font-size:24px;margin:0;font-weight:700;">3 passos para dominar a plataforma</h1>
  </td></tr>
  <tr><td style="padding:32px 40px;">
    <p style="color:#475569;font-size:14px;line-height:1.7;margin:0 0 28px;">Ol&aacute; <strong>{nome}</strong>, preparamos um guia r&aacute;pido para voc&ecirc; aproveitar ao m&aacute;ximo nossa plataforma.</p>
    <table width="100%" cellpadding="0" cellspacing="0">
      <tr><td style="padding-bottom:20px;">
        <table width="100%" cellpadding="0" cellspacing="0"><tr>
          <td style="width:44px;vertical-align:top;"><div style="width:40px;height:40px;background:#0369a1;border-radius:10px;text-align:center;line-height:40px;color:#fff;font-weight:800;font-size:16px;">1</div></td>
          <td style="padding-left:14px;">
            <h3 style="color:#1e293b;font-size:15px;margin:0 0 4px;font-weight:600;">Configure seu perfil</h3>
            <p style="color:#64748b;font-size:13px;line-height:1.5;margin:0;">Adicione foto, dados da empresa e prefer&ecirc;ncias de notifica&ccedil;&atilde;o para personalizar sua experi&ecirc;ncia.</p>
          </td>
        </tr></table>
      </td></tr>
      <tr><td style="padding-bottom:20px;">
        <table width="100%" cellpadding="0" cellspacing="0"><tr>
          <td style="width:44px;vertical-align:top;"><div style="width:40px;height:40px;background:#0369a1;border-radius:10px;text-align:center;line-height:40px;color:#fff;font-weight:800;font-size:16px;">2</div></td>
          <td style="padding-left:14px;">
            <h3 style="color:#1e293b;font-size:15px;margin:0 0 4px;font-weight:600;">Importe seus contatos</h3>
            <p style="color:#64748b;font-size:13px;line-height:1.5;margin:0;">Fa&ccedil;a upload de uma planilha CSV ou adicione manualmente seus contatos e empresas.</p>
          </td>
        </tr></table>
      </td></tr>
      <tr><td>
        <table width="100%" cellpadding="0" cellspacing="0"><tr>
          <td style="width:44px;vertical-align:top;"><div style="width:40px;height:40px;background:#0369a1;border-radius:10px;text-align:center;line-height:40px;color:#fff;font-weight:800;font-size:16px;">3</div></td>
          <td style="padding-left:14px;">
            <h3 style="color:#1e293b;font-size:15px;margin:0 0 4px;font-weight:600;">Crie seu primeiro neg&oacute;cio</h3>
            <p style="color:#64748b;font-size:13px;line-height:1.5;margin:0;">Adicione oportunidades ao pipeline e acompanhe cada etapa do processo de vendas.</p>
          </td>
        </tr></table>
      </td></tr>
    </table>
  </td></tr>
  <tr><td style="padding:0 40px 28px;text-align:center;">
    <a href="#" style="display:inline-block;background:#0369a1;color:#fff;font-size:14px;font-weight:700;padding:12px 36px;border-radius:8px;text-decoration:none;">Come&ccedil;ar agora</a>
  </td></tr>
  <tr><td style="background:#f8fafc;padding:20px 40px;text-align:center;border-top:1px solid #e2e8f0;">
    <p style="color:#94a3b8;font-size:11px;margin:0;">Precisa de ajuda? <a href="#" style="color:#0369a1;text-decoration:underline;">Fale com nosso suporte</a> &bull; <a href="#" style="color:#0369a1;text-decoration:underline;">Cancelar inscri&ccedil;&atilde;o</a></p>
  </td></tr>
</table>`,
  },
  {
    id: "black-friday",
    name: "Black Friday",
    description: "Template dark para grandes promo&ccedil;&otilde;es",
    color: "#1e293b",
    icon: "promo",
    html: `<table width="100%" cellpadding="0" cellspacing="0" style="max-width:600px;margin:0 auto;font-family:'Segoe UI',Arial,Helvetica,sans-serif;background:#0f172a;">
  <tr><td style="padding:40px;text-align:center;">
    <p style="color:#fbbf24;font-size:12px;text-transform:uppercase;letter-spacing:4px;margin:0 0 12px;font-weight:700;">Black Friday</p>
    <h1 style="color:#ffffff;font-size:44px;margin:0 0 8px;font-weight:900;">At&eacute; 70% OFF</h1>
    <p style="color:#94a3b8;font-size:15px;margin:0;">As melhores ofertas do ano est&atilde;o aqui</p>
    <div style="width:100%;height:1px;background:linear-gradient(90deg,transparent,#fbbf24,transparent);margin:24px 0;"></div>
  </td></tr>
  <tr><td style="padding:0 40px;">
    <table width="100%" cellpadding="0" cellspacing="0">
      <tr>
        <td width="48%" style="vertical-align:top;">
          <div style="background:#1e293b;border-radius:12px;padding:20px;text-align:center;border:1px solid #334155;">
            <div style="width:80px;height:80px;background:#334155;border-radius:12px;margin:0 auto 12px;line-height:80px;font-size:32px;">&#128187;</div>
            <p style="color:#f8fafc;font-size:14px;font-weight:600;margin:0 0 4px;">Produto Premium</p>
            <p style="color:#64748b;font-size:12px;text-decoration:line-through;margin:0 0 2px;">R$ 599,90</p>
            <p style="color:#fbbf24;font-size:20px;font-weight:800;margin:0;">R$ 179,97</p>
          </div>
        </td>
        <td width="4%"></td>
        <td width="48%" style="vertical-align:top;">
          <div style="background:#1e293b;border-radius:12px;padding:20px;text-align:center;border:1px solid #334155;">
            <div style="width:80px;height:80px;background:#334155;border-radius:12px;margin:0 auto 12px;line-height:80px;font-size:32px;">&#127912;</div>
            <p style="color:#f8fafc;font-size:14px;font-weight:600;margin:0 0 4px;">Produto Exclusivo</p>
            <p style="color:#64748b;font-size:12px;text-decoration:line-through;margin:0 0 2px;">R$ 399,90</p>
            <p style="color:#fbbf24;font-size:20px;font-weight:800;margin:0;">R$ 119,97</p>
          </div>
        </td>
      </tr>
    </table>
  </td></tr>
  <tr><td style="padding:28px 40px;text-align:center;">
    <a href="#" style="display:inline-block;background:#fbbf24;color:#0f172a;font-size:16px;font-weight:800;padding:16px 48px;border-radius:8px;text-decoration:none;">Aproveitar ofertas</a>
    <p style="color:#64748b;font-size:12px;margin:12px 0 0;">Ofertas v&aacute;lidas enquanto durarem os estoques</p>
  </td></tr>
  <tr><td style="padding:20px 40px;text-align:center;border-top:1px solid #1e293b;">
    <p style="color:#475569;font-size:11px;margin:0;"><a href="#" style="color:#fbbf24;text-decoration:underline;">Cancelar inscri&ccedil;&atilde;o</a></p>
  </td></tr>
</table>`,
  },
  {
    id: "resumo-semanal",
    name: "Resumo Semanal",
    description: "Report autom&aacute;tico de m&eacute;tricas e atividades",
    color: "#f1f5f9",
    icon: "newsletter",
    html: `<table width="100%" cellpadding="0" cellspacing="0" style="max-width:600px;margin:0 auto;font-family:'Segoe UI',Arial,Helvetica,sans-serif;background:#ffffff;">
  <tr><td style="background:#1e293b;padding:28px 40px;">
    <table width="100%" cellpadding="0" cellspacing="0"><tr>
      <td><p style="color:#94a3b8;font-size:11px;text-transform:uppercase;letter-spacing:2px;margin:0;font-weight:600;">Relat&oacute;rio</p>
        <h1 style="color:#ffffff;font-size:22px;margin:4px 0 0;font-weight:700;">Resumo da Semana</h1></td>
      <td style="text-align:right;"><p style="color:#64748b;font-size:12px;margin:0;">24 - 30 Mar 2026</p></td>
    </tr></table>
  </td></tr>
  <tr><td style="padding:28px 40px;">
    <p style="color:#475569;font-size:14px;margin:0 0 20px;">Ol&aacute; <strong>{nome}</strong>, aqui est&aacute; o resumo da sua semana:</p>
    <table width="100%" cellpadding="0" cellspacing="0">
      <tr>
        <td width="32%" style="text-align:center;padding:16px;background:#f8fafc;border-radius:12px;">
          <p style="color:#1e293b;font-size:28px;font-weight:800;margin:0;">47</p>
          <p style="color:#64748b;font-size:11px;margin:4px 0 0;">Neg&oacute;cios abertos</p>
        </td>
        <td width="2%"></td>
        <td width="32%" style="text-align:center;padding:16px;background:#f8fafc;border-radius:12px;">
          <p style="color:#059669;font-size:28px;font-weight:800;margin:0;">12</p>
          <p style="color:#64748b;font-size:11px;margin:4px 0 0;">Fechados (ganhos)</p>
        </td>
        <td width="2%"></td>
        <td width="32%" style="text-align:center;padding:16px;background:#f8fafc;border-radius:12px;">
          <p style="color:#1e293b;font-size:28px;font-weight:800;margin:0;">R$ 84k</p>
          <p style="color:#64748b;font-size:11px;margin:4px 0 0;">Valor pipeline</p>
        </td>
      </tr>
    </table>
  </td></tr>
  <tr><td style="padding:0 40px 28px;">
    <h3 style="color:#1e293b;font-size:14px;margin:0 0 12px;font-weight:600;">Atividades recentes</h3>
    <table width="100%" cellpadding="0" cellspacing="0" style="border:1px solid #e2e8f0;border-radius:10px;overflow:hidden;">
      <tr><td style="padding:12px 16px;border-bottom:1px solid #f1f5f9;">
        <table width="100%"><tr><td><span style="color:#059669;font-size:12px;">&#9679;</span> <span style="color:#475569;font-size:13px;">5 neg&oacute;cios avan&ccedil;aram de etapa</span></td><td style="text-align:right;color:#94a3b8;font-size:11px;">Hoje</td></tr></table>
      </td></tr>
      <tr><td style="padding:12px 16px;border-bottom:1px solid #f1f5f9;">
        <table width="100%"><tr><td><span style="color:#2563eb;font-size:12px;">&#9679;</span> <span style="color:#475569;font-size:13px;">18 tarefas conclu&iacute;das</span></td><td style="text-align:right;color:#94a3b8;font-size:11px;">Esta semana</td></tr></table>
      </td></tr>
      <tr><td style="padding:12px 16px;">
        <table width="100%"><tr><td><span style="color:#f59e0b;font-size:12px;">&#9679;</span> <span style="color:#475569;font-size:13px;">3 novos contatos adicionados</span></td><td style="text-align:right;color:#94a3b8;font-size:11px;">Esta semana</td></tr></table>
      </td></tr>
    </table>
  </td></tr>
  <tr><td style="padding:0 40px 28px;text-align:center;">
    <a href="#" style="display:inline-block;background:#1e293b;color:#fff;font-size:14px;font-weight:700;padding:12px 36px;border-radius:8px;text-decoration:none;">Ver dashboard completo</a>
  </td></tr>
  <tr><td style="background:#f8fafc;padding:20px 40px;text-align:center;border-top:1px solid #e2e8f0;">
    <p style="color:#94a3b8;font-size:11px;margin:0;">Recebido automaticamente. <a href="#" style="color:#1e293b;text-decoration:underline;">Gerenciar prefer&ecirc;ncias</a> &bull; <a href="#" style="color:#1e293b;text-decoration:underline;">Cancelar inscri&ccedil;&atilde;o</a></p>
  </td></tr>
</table>`,
  },
];

export default STARTER_TEMPLATES;
